import TextInput from './TextInput';
import { formatInternalDate, formatInternalTime } from '../lib/DateTime.js';
import InputContainer from './InputContainer';
import { useEffect, useState } from 'react';

const DateTimeInput = ({
    value,
    label,
    id,
    onChange,
    className,
    dateLabel,
    timeLabel,
}) => {
    const [dateInput, setDateInput] = useState(
        !!value ? formatInternalDate(value) : '',
    );
    const date = !!value ? formatInternalDate(value) : '';
    const time = !!value ? formatInternalTime(value) : '';
    const today = formatInternalDate(new Date());

    function update(timeStr) {
        const d = new Date(timeStr);

        if (!isNaN(d)) {
            onChange(d);
        } else {
            onChange('');
        }
    }

    useEffect(() => {
        // If we entered a valid date then send an update event
        const parts = dateInput.split('-');
        const year = parseInt(parts[0]);

        if (!dateInput || year > 2020) {
            update(`${dateInput} ${time || '00:00'}`);
        }
    }, [dateInput]);

    useEffect(() => {
        // Update the local dateInput if it changed
        if (!value) {
            // Clear it out
            setDateInput('');
        }

        const date = formatInternalDate(value);
        setDateInput(date);
    }, [value]);

    return (
        <InputContainer label={label} id={id}>
            <div className={`flex items-center gap-x-4 ${className}`}>
                <TextInput
                    label={dateLabel || 'Date'}
                    type="date"
                    className="w-full"
                    inputClassName="w-full"
                    value={dateInput}
                    onChange={setDateInput}
                />
                <TextInput
                    label={timeLabel || 'Time'}
                    type="time"
                    value={time}
                    className="w-full"
                    inputClassName="w-full"
                    onChange={newTime => {
                        update(`${date || today} ${newTime}`);
                    }}
                />
            </div>
        </InputContainer>
    );
};

export default DateTimeInput;
